import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, BookOpen, Shield, Truck, Heart, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden" data-testid="footer-section">
      {/* Final CTA section */}
      <div className="bg-indigo-950 py-20 sm:py-28 relative">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(244,63,94,0.15),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(251,191,36,0.1),transparent_50%)]" />

        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6" data-testid="footer-cta-heading">
              Every Child Deserves to Be the Hero
            </h2>
            <p className="text-base sm:text-lg text-white/50 max-w-xl mx-auto mb-10 leading-relaxed">
              Don't let this be just another tab you close. Your child's magical storybook is 3 clicks away.
            </p>

            <Button
              data-testid="footer-cta-button"
              className="rounded-full bg-rose-500 hover:bg-rose-400 text-white font-bold text-lg px-10 py-7 shadow-2xl shadow-rose-500/30 hover:-translate-y-1 hover:shadow-3xl transition-all group"
            >
              Create My Child's Book Now
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              <span className="text-rose-200 ml-2 text-sm">Rs.499</span>
            </Button>

            {/* Trust pills */}
            <div className="flex flex-wrap justify-center gap-4 mt-8">
              <div className="flex items-center gap-2 text-sm text-white/40">
                <Shield className="w-4 h-4" />
                <span>Secure Payment (Razorpay)</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/40">
                <Truck className="w-4 h-4" />
                <span>Free Shipping above Rs.999</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/40">
                <Heart className="w-4 h-4" />
                <span>100% Happiness Guarantee</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom footer */}
      <div className="bg-indigo-950 border-t border-white/5 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-rose-500 flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-white" />
              </div>
              <span className="text-lg font-bold text-white tracking-tight" style={{ fontFamily: "'Fredoka', sans-serif" }}>
                Bala<span className="text-rose-400">katha</span>
              </span>
            </div>

            <div className="flex items-center gap-6">
              <a href="#how-it-works" className="text-xs text-white/30 hover:text-white/60 transition-colors font-medium">How It Works</a>
              <a href="#story-preview" className="text-xs text-white/30 hover:text-white/60 transition-colors font-medium">Stories</a>
              <a href="#social-proof" className="text-xs text-white/30 hover:text-white/60 transition-colors font-medium">Reviews</a>
              <a href="#faq" className="text-xs text-white/30 hover:text-white/60 transition-colors font-medium">FAQ</a>
            </div>

            <div className="flex items-center gap-2 text-xs text-white/30">
              <Phone className="w-3 h-3" />
              <span>WhatsApp: +91-XXXXX-XXXXX</span>
            </div>
          </div>

          <div className="text-center mt-6 pt-6 border-t border-white/5">
            <p className="text-xs text-white/20">
              &copy; {new Date().getFullYear()} Balakatha. Made with love for little heroes everywhere.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
